/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsDesktopEnableUserChatsModel,
  IChatsDesktopEnableUserChatsRequest,
  IMappers,
  IChatsDesktopEnableUserChatsResponse,
  IChatsDesktopEnableUserChatsResponseError,
  TChatsDesktopEnableUserChatsResponse,
} from './types';

const defaultConfig: TChatsDesktopEnableUserChatsModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'agencies-settings',
  pathApi: '/v1/chats/desktop/enable-user-chats/',
  hostType: 'api',
} as TChatsDesktopEnableUserChatsModel;

function createChatsDesktopEnableUserChatsModel(
  parameters: IChatsDesktopEnableUserChatsRequest,
): TChatsDesktopEnableUserChatsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsDesktopEnableUserChatsOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IChatsDesktopEnableUserChatsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchChatsDesktopEnableUserChats<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsDesktopEnableUserChatsOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TChatsDesktopEnableUserChatsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createChatsDesktopEnableUserChatsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IChatsDesktopEnableUserChatsResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IChatsDesktopEnableUserChatsResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TChatsDesktopEnableUserChatsResponse;
}

export { defaultConfig, createChatsDesktopEnableUserChatsModel, fetchChatsDesktopEnableUserChats };
